import { Helmet } from 'react-helmet-async';
import { filter } from 'lodash';
import { sentenceCase } from 'change-case';
import { useState, useEffect } from 'react';
// @mui
import {
  Card,
  Table,
  Stack,
  Paper,
  Avatar,
  Button,
  Popover,
  Checkbox,
  TableRow,
  MenuItem,
  TableBody,
  TableCell,
  Container,
  Typography,
  IconButton,
  TableContainer,
  TablePagination,
} from '@mui/material';
import { useDispatch } from 'react-redux';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

// components

// sections
// mock
import moment from 'moment';
import { updateGameAction } from 'src/redux/actions/masterGameAction';
import CreateAndUpdateGameTypeModal from 'src/sections/@dashboard/gameTypes/CreateAndUpdateGameTypeModal';
import { loadingStartAction, loadingStopAction } from 'src/redux/actions/loadingActions';
import { LoadingButton } from '@mui/lab';
import UserWalletUpdate from 'src/sections/@dashboard/wallet/UserWalletUpdate';
import { row_per_page_data } from 'src/utils/commonUtils';
import Scrollbar from 'src/components/scrollbar/Scrollbar';
import { useParams } from 'react-router-dom';
import api from 'src/api';
import UserListHead from '../user/UserListHead';
import Label from 'src/components/label/Label';

// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: '_', label: 'S/N', alignRight: false },
  { id: 'points', label: 'Points', alignRight: false },
  { id: 'transaction_note', label: 'Transaction Note', alignRight: false },
  { id: 'createdAt', label: 'Date', alignRight: false },
];

// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(array, (_user) => _user.name.toLowerCase().indexOf(query.toLowerCase()) !== -1);
  }
  return stabilizedThis.map((el) => el[0]);
}

export default function UserJourney({ type, falseLoading }) {
  const dispatch = useDispatch();

  let { id } = useParams();

  const [open, setOpen] = useState(null);

  const [page, setPage] = useState(0);

  const [order, setOrder] = useState('asc');

  const [selected, setSelected] = useState([]);

  const [orderBy, setOrderBy] = useState('name');

  const [filterName, setFilterName] = useState('');

  const [rowsPerPage, setRowsPerPage] = useState(row_per_page_data[0]);

  const [withdrawalReq, setWalletData] = useState([]);

  const [selectedGame, setSelectedGame] = useState('');

  const handleOpenMenu = (event) => {
    setOpen(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setOpen(null);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = withdrawalReq.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
    }
    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setPage(0);
    setRowsPerPage(parseInt(event.target.value, 10));
  };

  const handleFilterByName = (event) => {
    setPage(0);
    setFilterName(event.target.value);
  };

  const getAllWallets = async () => {
    dispatch(loadingStartAction());
    const response = await api.get('/wallet');
    setWalletData(response.data);
    dispatch(loadingStopAction());
  };

  const deleteWallet = async () => {
    handleCloseMenu();
    dispatch(loadingStartAction());
    await api.delete(`/wallet/${selectedGame._id}`);
    getAllWallets();
  };

  const editgame = async () => {
    handleCloseMenu();
    dispatch(updateGameAction(selectedGame));
  };

  const [date, setDate] = useState();

  let getFilteredData = async (d) => {
    let endpoints = `/wallet//user-wallet/${id}`;
    const response = await api.get(endpoints);
    setWalletData(response.data);
  };

  useEffect(() => {
    // if (type === 'dashboard') {
    getFilteredData();
    // } else {
    //   getAllWallets();
    // }
  }, []);

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - withdrawalReq?.length) : 0;

  const filteredFinalData = applySortFilter(withdrawalReq, getComparator(order, orderBy), filterName);

  const isNotFound = !filteredFinalData.length && !!filterName;

  return (
    <>
      <Helmet>
        <title> User | Minimal UI </title>
      </Helmet>

      <Container>
        {/* <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
        <Typography variant="h4" gutterBottom>
           Deposit History
          </Typography>
          <Stack direction="row" alignItems="center">
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DemoContainer components={['DatePicker']}>
                <DatePicker
                  label="Select Date"
                  value={date}
                  onChange={(newValue) => {
                    getFilteredData(newValue)
                    setDate(newValue);
                  }}
                />
              </DemoContainer>
            </LocalizationProvider>
          </Stack>
        </Stack> */}

        <Card>
          {/* <UserListToolbar numSelected={selected.length} filterName={filterName} onFilterName={handleFilterByName} /> */}

          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <UserListHead
                  order={order}
                  orderBy={orderBy}
                  headLabel={TABLE_HEAD}
                  rowCount={withdrawalReq.length}
                  numSelected={selected.length}
                  onRequestSort={handleRequestSort}
                  onSelectAllClick={handleSelectAllClick}
                />
                <TableBody>
                  {filteredFinalData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row,index) => {
                    const { _id, user, status, points, payment_method, transaction_type, transaction_note, createdAt } =
                      row;
                    const selectedUser = selected.indexOf(user?.name) !== -1;

                    return (
                      <TableRow hover key={_id} tabIndex={-1} role="checkbox" selected={selectedUser}>
                        <TableCell padding="checkbox">
                          {/* <Checkbox checked={selectedUser} onChange={(event) => handleClick(event, user?.name)} /> */}
                        </TableCell>
                        <TableCell align="left">
                        {index+1}
                        </TableCell>


                        <TableCell align="left">
                          <Label
                            color={
                              transaction_type === 'debit'
                                ? 'error'
                                : transaction_type === 'credit'
                                ? 'success'
                                : 'info'
                            }

                           
                          >
                            {transaction_type === 'debit' ? '-' :  transaction_type === 'credit' ? '+' : ""} {points}
                          </Label>
                        </TableCell>
                        <TableCell align="left">{transaction_note}</TableCell>
                        <TableCell align="left">{moment(createdAt).format('MMMM Do YYYY, hh:mm:ss a')}</TableCell>
                      </TableRow>
                    );
                  })}
                  {emptyRows > 0 && (
                    <TableRow style={{ height: 53 * emptyRows }}>
                      <TableCell colSpan={6} />
                    </TableRow>
                  )}
                </TableBody>

                {isNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                        <Paper
                          sx={{
                            textAlign: 'center',
                          }}
                        >
                          <Typography variant="h6" paragraph>
                            Not found
                          </Typography>

                          <Typography variant="body2">
                            No results found for &nbsp;
                            <strong>&quot;{filterName}&quot;</strong>.
                            <br /> Try checking for typos or using complete words.
                          </Typography>
                        </Paper>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>

          <TablePagination
            rowsPerPageOptions={row_per_page_data}
            component="div"
            count={filteredFinalData.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Card>
      </Container>

      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleCloseMenu}
        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            p: 1,
            width: 140,
            '& .MuiMenuItem-root': {
              px: 1,
              typography: 'body2',
              borderRadius: 0.75,
            },
          },
        }}
      >
        <MenuItem onClick={() => deleteWallet()} sx={{ color: 'error.main' }}>
          {/* <Iconify icon={'eva:trash-2-outline'} sx={{ mr: 2 }} /> */}
          Delete
        </MenuItem>
      </Popover>
    </>
  );
}
